import axios from 'axios';
import FaqEntity from './faq-entity';
import PendingRequestEntity from '../entities/pending-request-entity';
import counterpart from 'counterpart';
import * as variables from 'frilans-finans/variables';

class FaqService {
  getFaqsAsObject (faqs) {
    const faqsById = {};

    faqs.forEach(faq => {
      faqsById[faq.id] = faq.acf;
    });

    return faqsById;
  }

  getGroupFaqs (faqsDictonary, group) {
    const questions = group.acf.question_group[0].question_group_q;
    return questions
      .filter(question => question.post_status === 'publish')
      .map(question => {
        const faq = faqsDictonary[question.ID];
        return {
          id: question.ID,
          q: faq ? faq.q_and_a_q : '',
          a: faq ? faq.q_and_a_a : '',
          groupId: group.id
        };
      });
  }

  hydrateCollection (groups, faqs) {
    const faqsDictonary = this.getFaqsAsObject(faqs);
    return groups
      .map(group => new FaqEntity(group.id, group.title.rendered, this.getGroupFaqs(faqsDictonary, group)))
      .reverse();
  }

  request (url) {
    const pendingRequest = new PendingRequestEntity();

    pendingRequest.promise = axios.get(url, {
      cancelToken: new axios.CancelToken(function executor (c) {
        pendingRequest.cancel = c;
      })
    });

    return pendingRequest.promise;
  }

  getGroups () {
    const url = counterpart.getLocale() === 'en'
      ? `${variables.frontUrl}/en/wp-json/wp/v2/fragegrupp?per_page=100`
      : `${variables.frontUrl}/wp-json/wp/v2/fragegrupp?per_page=100`;

    return this.request(url);
  }

  getFaqs (page = 1) {
    const url = counterpart.getLocale() === 'en'
      ? `${variables.frontUrl}/en/wp-json/wp/v2/fragor-och-svar/?per_page=100&page=${page}`
      : `${variables.frontUrl}/wp-json/wp/v2/fragor-och-svar/?per_page=100&page=${page}`;

    return this.request(url);
  }

  get () {
    const pendingRequest = new PendingRequestEntity();

    if (counterpart.getLocale() === 'se') {
      pendingRequest.promise = axios.all([this.getGroups(), this.getFaqs(1), this.getFaqs(2)])
      .then(axios.spread((groups, faqs1, faqs2) => this.hydrateCollection(groups.data, faqs1.data.concat(faqs2.data))));
    } else {
      pendingRequest.promise = axios.all([this.getGroups(), this.getFaqs(1)])
      .then(axios.spread((groups, faqs1) => this.hydrateCollection(groups.data, faqs1.data)));
    }

    return pendingRequest;
  }
}

export default new FaqService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/faq/faq-service.js
 **/